import Picture4 from "../assets/homePage/04.jpg";
import Picture5 from "../assets/homePage/05.jpg";
import Picture6 from "../assets/homePage/06.jpeg";
import Picture7 from "../assets/homePage/07.jpg";
import Picture8 from "../assets/homePage/08.jpg";
import Picture9 from "../assets/homePage/09.jpg";
import Picture10 from "../assets/homePage/010.jpg";

const catagories = [
  {
    id: 1,
    name: "Audio Video Systems",
    description: "AV systems are truly all around us, helping to entertain, inform and enlighten us every day! \n AV systems explain different systems can be integrated and control together.",
    image: Picture4,
  },
  {
    id: 2,
    name: "Public Address & Voice Evacuation Systems",
    description: "Public Address and Voice alarm evacuation systems allow safe and controlled building evacuation to be managed in the case of an emergency. \n Clear voice pre-recorded messages can be initiated from the system to aid building evacuation. The systems can also be used to provide background music and paging system solutions.",
    image: Picture5,
  },
  {
    id: 3,
    name: "Fire Detection Alarm System",
    description: "A fire alarm system warns people when smoke, fire, carbon monoxide or other fire-related or general notification emergency / emergencies are detected. These alarms activated automatically through detectors or may also be activated via manual fire alarm activation devices such as manual call points. Alarms system includes sounders or horns. They can also be speaker strobes which sound an alarm, followed by a voice evacuation message which warns people inside the building not to use the elevators.",
    image: Picture6,
  },
  {
    id: 4,
    name: "Security System",
    description: "The most basic definition of any security system is found in its name. It is literally a means or method by which something is secured through a system of interworking components and devices.",
    image: Picture7,
  },
  {
    id: 5,
    name: "Home Automation & Smart Homes",
    description: "A home automation system monitor and/or control home attributes such as lighting, climate, entertainment systems, and appliances. It may also include home security such as access control and alarm systems. When connected with the Internet, home devices are an important constituent of the Internet of Things.",
    image: Picture8,
  },
  {
    id: 6,
    name: "Automatic Entrance Solutions",
    description: "The most basic definition of any automatic entrance solutions is manual entrance equipped with a power-operated mechanism and controls that open and close the device automatically upon receipt of a momentary actuating signal.",
    image: Picture9,
  },
  {
    id: 7,
    name: "Other ELV Solutions",
    description: "•	\n•	Tower Clock.\n•	Parking guidance and management system.\n•	Queuing Management System.",
    services: [ "Master Clock System.", "Tower Clock.", "Parking guidance and management system.", "Queuing Management System." ],
    image: Picture10,
  }

]

export default catagories;